// extracted by mini-css-extract-plugin
module.exports = {"popModal":"wrapper_popModal__5T7Ez","slideRight":"wrapper_slideRight__nyYlZ","slideLeft":"wrapper_slideLeft__nVDdn","bottomModal":"wrapper_bottomModal___xuLF"};